import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/gfx/Goomy.jsx");
